module.exports = __webpack_public_path__ + "img/p1-c2-p2.628b8abe.jpg";